import { createContext, useContext } from 'react';
import type { Lang, MessageId, Vars } from './messages';

export type TFunction = (id: MessageId, vars?: Vars) => string;

export interface I18nValue {
  lang: Lang;
  setLang: (lang: Lang) => void;
  t: TFunction;
}

export const I18nContext = createContext<I18nValue | null>(null);

export function useI18n(): I18nValue {
  const ctx = useContext(I18nContext);
  if (!ctx) throw new Error('useI18n خارج I18nProvider');
  return ctx;
}

/** الاستعمال الشائع: `const t = useT()` ثم `t('login.title')` */
export function useT(): TFunction {
  return useI18n().t;
}
